export default {
  DemoFormPopup: 'DemoFormPopup',
  ForgotPasswordPopup: 'ForgotPasswordPopup',
  ChangePasswordPopup: 'ChangePasswordPopup',
  AuthenticateRequirePopup: 'AuthenticateRequirePopup',
  ChooseSchoolLevelPopup: 'ChooseSchoolLevelPopup',
  MobileProfileSearchPopup: 'MobileProfileSearchPopup',
}
